import { i18n } from 'fishx';
import get from 'lodash/get';
import { ADDR_DOWN, ADDRESS_NAME } from '@/utils';

// pinCode输入完毕后要进行三次查询
// 一次根据pinCode查询对应的district
// 二次根据查询出来的district的parentId查询district对应的state
// 三次根据查询出来的district的addreddId向下查询main locality
// 约定：model中分别存在对应state/district/mainLocality/subLocality地址的的同名属性
export async function handlePinCodeBlur({ e, resetFields, setFieldsValue, dispatch, modelName }) {
  const { value } = e.target;
  if (value) {
    const result = await dispatch({
      type: 'business/qryAddressListByPinCode',
      payload: { pinCode: value },
      modelName,
    });
    if (result) {
      resetFields(['state']);
      setFieldsValue({ postCode: value });
    }
  }
}

// 根据mainLocality的addressId查询下一级地址信息，即subLocality
export async function handleMainLocalityChange({ addressId, dispatch, setFieldsValue, modelName }) {
  const result = await dispatch({
    type: 'business/qryAddrListByMainLocality',
    payload: { addressId, addressLevel: ADDR_DOWN },
    modelName,
  });
  if (result) {
    setFieldsValue({ mainLocality: addressId });
  }
}

export function documentNbrValidator({ type, getFieldValue, certTypeList }) {
  // 根据选中的证件类型校验证件号码
  return (rule, value, callback) => {
    if (value) {
      const certType = getFieldValue(type);
      const selectedSert = (certTypeList || []).find(cert => cert.certTypeId === certType);
      const maxLength = get(selectedSert, 'maxLength');
      const minLength = get(selectedSert, 'minLength');
      const nbrExample = get(selectedSert, 'nbrExample');
      const regStr = get(selectedSert, 'regExp');
      const regExp = new RegExp(regStr);
      
      if (regStr && !regExp.test(value)) {
        callback(nbrExample);
      }
      if (minLength && value.length < minLength) {
        if (maxLength) {
          callback(`${i18n('BUSINESS_DOC_NBR_SHOULD_LONGER_THAN')} ${minLength} ${i18n('BUSINESS_SHORTER_THAN')} ${maxLength}`); // Document's number should longer than xxx and less than xxx
        } else {
          callback(`${i18n('BUSINESS_DOC_NBR_SHOULD_LONGER_THAN')} ${minLength}`); // Document's number should longer than xxx
        }
      }

      if (maxLength && value.length > maxLength) {
        if (maxLength) {
          callback(`${i18n('BUSINESS_DOC_NBR_SHOULD_LONGER_THAN')} ${minLength} ${i18n('BUSINESS_SHORTER_THAN')} ${maxLength}`);
        } else {
          callback(`${i18n('BUSINESS_DOC_NBR_SHOULD_SHORTER_THAN')} ${maxLength}`);
        }
      }
    }

    callback();
  };
}

// 处理附件参数，表单中生成的附件和手动设置的附件参数结构不一致，此方法能抹平差距
// 如果是本次上传的附件，那么附件信息是放在表单数据的fileList对象里的
// 如果本次没有上传附件，那么附件信息就是表单数据
export function generateDocList(fileData) {
  if (get(fileData, 'fileList')) {
    return (get(fileData, 'fileList') || [])
      .filter(file => file.status === 'done')
      .map(file => ({ status: 'done', uid: get(file, 'response.data.docId'), name: get(file, 'name'), attachUrl: get(file, 'response.data.docId'), attachURL: get(file, 'response.data.docId'), attachName: get(file, 'name') }));
  }
  if (typeof (fileData || []).map === 'function') {
    return (fileData || []).map(file => ({ status: 'done', uid: get(file, 'attachUrl'), name: get(file, 'name'), attachUrl: get(file, 'attachUrl'), attachName: get(file, 'name'), attachURL: get(file, 'attachUrl') }));
  }
  return [];
}

export function generateAddressToolFunc({ dispatch, modelName, subLocalityOpts, setFieldsValue }) {
  function qryState() {
    dispatch({
      type: 'business/qryAddrListByAddressId',
      payload: { addressLevel: ADDR_DOWN },
      modelName,
      addressName: ADDRESS_NAME.STATE,
    });
  }

  function handleStateChange(addressId) {
    dispatch({
      type: 'business/qryAddrListByAddressId',
      payload: { addressLevel: ADDR_DOWN, addressId },
      modelName,
      addressName: ADDRESS_NAME.CITY,
    });
    setFieldsValue({ district: undefined, mainLocality: undefined, subLocality: undefined, postCode: undefined });
  }

  function handleDistrictChange(addressId) {
    dispatch({
      type: 'business/qryAddrListByAddressId',
      payload: { addressLevel: ADDR_DOWN, addressId },
      modelName,
      addressName: ADDRESS_NAME.MAIN_LOCALITY,
    });
    setFieldsValue({ mainLocality: undefined, subLocality: undefined, postCode: undefined });
  }
  // eslint-disable-next-line no-shadow
  function handleMainLocalityChange(addressId) {
    dispatch({
      type: 'business/qryAddrListByAddressId',
      payload: { addressLevel: ADDR_DOWN, addressId },
      modelName,
      addressName: ADDRESS_NAME.SUB_LOCALITY,
    });
    setFieldsValue({ subLocality: undefined, postCode: undefined });
  }

  function handleSubLocalityChange(addressId) {
    for (let i = 0; i < subLocalityOpts.length; i += 1) {
      if (get(subLocalityOpts[i], 'addressId') === addressId) {
        setFieldsValue({ postCode: get(subLocalityOpts[i], 'pinCode') });
        break;
      }
    }
  }

  return { qryState, handleStateChange, handleDistrictChange, handleMainLocalityChange, handleSubLocalityChange };
}
